import { AxiosError } from 'axios';
import { useState, useCallback } from 'react';
import { IApplicantData } from '../../models/jobs/singleJobApplicants.model';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../models/https';
import useHttps from '../useHttps';

const useGetAcceptedJobApplicants = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [applicantData, setApplicantData] = useState<any>();

  const onGetAcceptedJobApplicantsSuccess = useCallback(
    ({ data, message }: SuccessHttpResponse<IApplicantData[]>) => {
      const filteredData = data.filter(
        (applicant) => applicant.status === 'ACCEPTED'
      );
      console.log(filteredData);
      setApplicantData(filteredData);
    },
    []
  );

  const onGetAcceptedJobApplicantsError = useCallback(
    (err: AxiosError<ErrorHttpResponse>) => {
      if (
        err.response?.status === 404 &&
        err.response?.data?.message === 'No application found'
      ) {
        onGetAcceptedJobApplicantsSuccess({
          status: 'success',
          data: [],
          message: 'No application found',
        });
        setLoading(false);
        return;
      }
      console.error(
        err?.message ??
          'Something went wrong while fetching accepted job applicants'
      );
    },
    [onGetAcceptedJobApplicantsSuccess]
  );

  const getAcceptedJobApplicants = useCallback(
    (jobId: string) => {
      const url: HttpConfig = {
        url: `jobs-service/jobs/${jobId}/applicants`,
        method: 'get',
      };

      return request(
        url,
        onGetAcceptedJobApplicantsSuccess,
        setLoading,
        onGetAcceptedJobApplicantsError
      );
    },
    [
      request,
      onGetAcceptedJobApplicantsSuccess,
      onGetAcceptedJobApplicantsError,
    ]
  );

  return { getAcceptedJobApplicants, loading, applicantData };
};

export default useGetAcceptedJobApplicants;
